import CacheManager from "@/components/cacheManager/CacheManager";

export async function sortDynamicAttributes(valueAttributesList) {
    const listWithNulls = [];
    const listWithAssignedOrder = [];
    let dynamicAttributes = await CacheManager.getDynamicAttributes();
    let categoryAttributes = await CacheManager.getCategoryAttributes();

    const allNull = valueAttributesList.every(item => item === null);
    if (allNull) {
        // wywołanie z historii logów danego produktu
        return;
    }
    valueAttributesList.forEach(valueAttribute => {
        let categoryAttribute = categoryAttributes[valueAttribute.categoryAttributesId];
        let dynamicAttribute = dynamicAttributes[categoryAttribute.dynamicAttributes];
        if (dynamicAttribute.order === null) {
            listWithNulls.push(valueAttribute);
        } else {
            listWithAssignedOrder.push(valueAttribute);
        }
    });


    listWithAssignedOrder.sort((valAttr1, valAttr2) => {
        let categoryAttribute1 = categoryAttributes[valAttr1.categoryAttributesId];
        let categoryAttribute2 = categoryAttributes[valAttr2.categoryAttributesId];
        let dynamicAttribute1 = dynamicAttributes[categoryAttribute1.dynamicAttributes];
        let dynamicAttribute2 = dynamicAttributes[categoryAttribute2.dynamicAttributes];
        return dynamicAttribute1.order - dynamicAttribute2.order;
    });


    listWithNulls.sort((dynAttr1, dynAttr2) => {
        let categoryAttribute1 = categoryAttributes[dynAttr1.categoryAttributesId];
        let categoryAttribute2 = categoryAttributes[dynAttr2.categoryAttributesId];
        let dynamicAttribute1 = dynamicAttributes[categoryAttribute1.dynamicAttributes];
        let dynamicAttribute2 = dynamicAttributes[categoryAttribute2.dynamicAttributes];
        const num1 = extractNumber(dynamicAttribute1.EID);
        const num2 = extractNumber(dynamicAttribute2.EID);
        return num1 - num2;
    });

    return listWithAssignedOrder.concat(listWithNulls);
}

function extractNumber(s) {
    const parts = s.split("-");
    return parseInt(parts[parts.length - 1], 10);
}